export const GET_FUND_SPOTLIGHT = "DASHBOARD@GET_FUND_SPOTLIGHT";
export const GET_FUND_SPOTLIGHT_INIT = "DASHBOARD@GET_FUND_SPOTLIGHT_INIT";
export const GET_FUND_SPOTLIGHT_SUCCESS =
  "DASHBOARD@GET_FUND_SPOTLIGHT_SUCCESS";
export const GET_FUND_SPOTLIGHT_FAILED = "DASHBOARD@GET_FUND_SPOTLIGHT_FAILED";

export const GET_LIST_OF_STRATEGIES = "DASHBOARD@GET_LIST_OF_STRATEGIES";
export const GET_LIST_OF_STRATEGIES_INIT =
  "DASHBOARD@GET_LIST_OF_STRATEGIES_INIT";
export const GET_LIST_OF_STRATEGIES_SUCCESS =
  "DASHBOARD@GET_LIST_OF_STRATEGIES_SUCCESS";
export const GET_LIST_OF_STRATEGIES_FAILED =
  "DASHBOARD@GET_LIST_OF_STRATEGIES_FAILED";

export const GET_RECENT_CHAT = "DASHBOARD@GET_RECENT_CHAT";
export const GET_RECENT_CHAT_INIT = "DASHBOARD@GET_RECENT_CHAT_INIT";
export const GET_RECENT_CHAT_SUCCESS = "DASHBOARD@GET_RECENT_CHAT_SUCCESS";
export const GET_RECENT_CHAT_FAILED = "DASHBOARD@GET_RECENT_CHAT_FAILED";

export const GET_MEETINGS = "DASHBOARD@GET_MEETINGS";
export const GET_MEETINGS_INIT = "DASHBOARD@GET_MEETINGS_INIT";
export const GET_MEETINGS_SUCCESS = "DASHBOARD@GET_MEETINGS_SUCCESS";
export const GET_MEETINGS_FAILED = "DASHBOARD@GET_MEETINGS_FAILED";

export const SET_TOKEN = "DASHBOARD@SET_TOKEN";

export const GET_RECENT_POST = "DASHBOARD@GET_RECENT_POST";
export const GET_RECENT_POST_INIT = "DASHBOARD@GET_RECENT_POST_INIT";
export const GET_RECENT_POST_SUCCESS = "DASHBOARD@GET_RECENT_POST_SUCCESS";
export const GET_RECENT_POST_FAILED = "DASHBOARD@GET_RECENT_POST_FAILED";

export const GET_DASHBOARD_CONFIG = "DASHBOARD@GET_DASHBOARD_CONFIG";
export const GET_DASHBOARD_CONFIG_INIT = "DASHBOARD@GET_DASHBOARD_CONFIG_INIT";
export const GET_DASHBOARD_CONFIG_SUCCESS =
  "DASHBOARD@GET_DASHBOARD_CONFIG_SUCCESS";
export const GET_DASHBOARD_CONFIG_FAILED =
  "DASHBOARD@GET_DASHBOARD_CONFIG_FAILED";

export const UPDATE_DASHBOARD_CONFIG = "DASHBOARD@UPDATE_DASHBOARD_CONFIG";
export const UPDATE_DASHBOARD_CONFIG_INIT =
  "DASHBOARD@UPDATE_DASHBOARD_CONFIG_INIT";
export const UPDATE_DASHBOARD_CONFIG_SUCCESS =
  "DASHBOARD@UPDATE_DASHBOARD_CONFIG_SUCCESS";
export const UPDATE_DASHBOARD_CONFIG_FAILED =
  "DASHBOARD@UPDATE_DASHBOARD_CONFIG_FAILED";
